import { render, staticRenderFns } from "./OrderMenuItem.vue?vue&type=template&id=6c103c87"
import script from "./OrderMenuItem.vue?vue&type=script&lang=ts"
export * from "./OrderMenuItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports